import store from "@/store/store"

export default class Messenger{

    static emitSuccess(msg) {
        store.commit('setSnack', {
            message: msg,
            color: 'success'
        })
    }

    static emitError(msg) {
        store.commit('setSnack', {
            message: msg,
            color: 'danger'
        })
    }
}